<nav id="nav" class="navbar">
  <div class="container navbar__wrapper">
    <a href="" class="navbar__brand"><img src="../assets/logo-brand.png" alt="mesonagreen" width="91" height="75"></a>
    <a href="" class="navbar__brandMobile"><img src="../assets/logo-brand.png" alt="mesonagreen" width="91" height="75"></a>
    <button class="navbar__toggle" (click)="Testing()"><i class="fa-solid fa-ellipsis-vertical"></i></button>
    <div class="navbar__menu">
      <ul class="navbar__nav" id="navMenu">
        <li class="navbar__item">
          <a routerLink="" class="navbar__link">Home</a>
        </li>
        <li class="navbar__item">
          <a routerLink="about" class="navbar__link">About</a>
        </li>
        <li class="navbar__item">
          <a routerLink="" class="navbar__link">Contact Us</a>
        </li>
        <li class="navbar__item navbar__item--withline">
          <a href="//blogs.mesonagreen.com" class="navbar__link" target="blank">Blogs</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>
<footer class="footer">
  <div class="container">
    <div class="footer__wrap">
      <div class="footer__row">
        <a class="footer__brand" href="#">
          Mesonagreen.com
        </a>
      </div>
      
      <div class="footer__left">
        <div class="footer__address">
          <h3>Address</h3>
          <div class="footer__addressLead">
            <!-- WA: +62 8777 4237 310<br> -->
            <span class="footer__addressCall">
              Whatsapp: <a href="https://wa.me/+6287774237310">+62 8777 4237 310</a><br>
              Email: <a href="mailto:management@mesonagreen.com">management@mesonagreen.com</a>
            </span>
          </div>
        </div>
      </div>
      <div class="footer__right">
        <div class="footer__social">
          <h3>Follow us on socialmedia</h3>
          <ul>
            <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
            <li><a href="#"><i class="fa-brands fa-twitter"></i></a></li>
            <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
            <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
            <li><a href="#"><i class="fa-brands fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
    <hr>

    <p>&copy; Mesonagreen 2022. All right reserved.</p>
  </div>
</footer>
<div class="floatingBtn">
  <a href="" class="floatingBtn__item floatingBtn__fb"><i class="fa-brands fa-facebook-f"></i></a>
  <a href="" class="floatingBtn__item floatingBtn__tw"><i class="fa-brands fa-twitter"></i></a>
  <a href="" class="floatingBtn__item floatingBtn__ig"><i class="fa-brands fa-instagram"></i></a>
  <a href="" class="floatingBtn__item floatingBtn__yt"><i class="fa-brands fa-youtube"></i></a>
  <a href="" class="floatingBtn__item floatingBtn__in"><i class="fa-brands fa-linkedin"></i></a>
  <a href="https://wa.me/+6287774237310" class="floatingBtn__item floatingBtn__wa" target="blank"><i class="fa-brands fa-whatsapp"></i></a>
</div>